import React from 'react';
import { Button, DialogContent, Typography } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';

import { ITimer, useTimer } from 'hooks';

import styles from './VerifyEmailDialog.module.scss';

const RESEND_TIMER_DURATION = 60;

export interface VerifyEmailDialogProps extends DialogProps {
  email: string;
  initialTimerValue?: number;
  onConfirm: () => Promise<void>;
}

export function VerifyEmailDialog({ onConfirm, email, initialTimerValue, ...rest }: VerifyEmailDialogProps) {
  const { t } = useTranslation('auth');
  const { seconds, startTimer }: ITimer = useTimer(initialTimerValue ?? 0);
  const isLongEmail = email.length > 28;

  const handleResend = (): void => {
    startTimer(RESEND_TIMER_DURATION);
    onConfirm();
  };

  return (
    <Dialog {...rest} className={styles.dialog}>
      <DialogContent>
        <Typography component='h4' variant='h4'>
          {t('verifyEmailDialogTitle')}
        </Typography>

        <Typography component='p' variant='body2'>
          {t('verifyEmailDialogSentTo')}{' '}
          <b className={styles.emailText + (isLongEmail ? ` ${styles.longEmailText}` : '')}>{email}</b>
        </Typography>

        <Typography component='p' variant='body2'>
          {t('verifyEmailDialogInstructionsLine1')}
          <br />
          {t('verifyEmailDialogInstructionsLine2')}
        </Typography>

        <Button variant='contained' onClick={handleResend} className={styles.formButton} disabled={!!seconds}>
          {t('verifyEmailDialogResendLink')}
          {seconds ? ` (${seconds})` : ''}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
